<template>
  <div class="main"
       @mousewheel="mousewheel($event)">
    <webheader></webheader>
    <div class="first-page "
         :class=" ver===1?'show':'hide'">
      <div class="page-content flex-left ">
        <div class="left-content">
          <div class="first-title"
               style="text-align:right"><span class='pr-16'>UE4全流程制作</span></div>
          <div class="flex-right"
               style="padding-top:48px;">
            <div class="text-gradient">
              <div class="en-title">
                Whole process production
              </div>
            </div>
          </div>
          <div class="desc">
            首家采用全引擎流程动画制作，并拥有自主知识产权的CG动画项目管理流程。
          </div>
          <div class="next-page flex-right"
               @click="ver=2">
            <img src="../assets/img/next.png" /> <span class="desc-text active  "> 下一页</span>
          </div>
        </div>
        <div class="right-content  ">
          <div class="home-page"
               style="width:100%;height:60%;top:160px;">
            <img src="../assets/img/technical/1.png"
                 alt=""
                 class="cover"></div>
        </div>
      </div>
    </div>
    <div class="second-page"
         :class=" ver===2?'show':'hide'">
      <div class="page-content flex-left ">
        <div class="left-content">
          <div class="first-title pr-16"
               style="text-align:right; "><span class='pr-16'> VICON光学捕捉系统 </span></div>
          <div class="flex-right"
               style="padding-top:48px;">
            <div class="text-gradient">
              <div class="en-title">
                Optical motion capture system
              </div>
            </div>
          </div>
          <div class="desc">
            引进结合好莱坞CG电影拍摄指定的英国VICON光学捕捉系统， 让动画的角色表演更自然流畅。
          </div>

          <div class="next-page flex-right"
               @click="ver=1">
            <img src="../assets/img/prev.png" /> <span class="desc-text active  "> 上一页</span>
          </div>
        </div>
        <div class="right-content  ">
          <div class="home-page"
               style="width:100%;height:60%;top:160px;">
            <img src="../assets/img/technical/4.png"
                 alt=""
                 class="cover"></div>
        </div>
      </div>
    </div>
    <tabfooter></tabfooter>
  </div>
</template>

<script>
import webheader from '@/components/webheader'
import tabfooter from '@/components/tabfooter'
export default {
  components: { tabfooter, webheader },
  name: 'technical',
  data () {
    return {
      ver: 1
    }
  },
  methods: {
    mousewheel (e) {
      e = e || window.event
      if (e.wheelDelta) {
        if (e.wheelDelta > 0) {
          if (this.ver > 1) {
            this.ver--
          }
        }
        if (e.wheelDelta < 0) {
          if (this.ver < 2) {
            this.ver++
          }
        }
      } else if (e.detail) {
        if (e.detail > 0) {
          if (this.ver > 1) {
            this.ver--
          }
        }
        if (e.detail < 0) {
          if (this.ver < 2) {
            this.ver++
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.show {
  animation: 1s fadeInUp;
  display: block;
}
.hide {
  animation: 1s backOutUp;
  display: none;
}
.desc-text {
  padding-left: 16px;
}
.next-page {
  cursor: pointer;
  padding-top: 80px;
  padding-right: 8px;
  height: 68px;
  line-height: 68px;
}
.desc {
  width: 570px;
  height: 66px;
  padding-top: 70px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 50px;
  color: rgba(222, 222, 222, 1);
  opacity: 1;
}
.left-content {
  text-align: right;
  padding: 110px;
  height: 60%;
}
.right-content {
  height: 100%;
  width: 50%;
  padding: 110px 0;
  position: relative;
}
.page-content {
  height: 100%;
  padding: 60px;
}
.first-page,
.second-page {
  height: calc(100% - 145px);
}
</style>



// WEBPACK FOOTER //
// src/view/technical.vue